export const navHeight = '4.5rem'; // Defined by MUI - AppBar (taken from MuiTab) height = 72px. Adjusted to rem (/16, assuming 16px base size).
export const navHeightMobile = '64px'; // Defined by MUI
export const clientLogoWidth = '14.0625rem';
export const stepNumberCircleDiameter = '2.1875rem';
